// Initialize Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyCyjGn9wYxZ4EyhI3wncosfcfOHzrhhyJg',
  authDomain: 'loova-864b3.firebaseapp.com',
  databaseURL: 'https://loova-864b3.firebaseio.com',
  projectId: 'loova-864b3',
  storageBucket: 'loova-864b3.appspot.com',
  messagingSenderId: '1045101580282',
  appId: '1:1045101580282:web:ae77a05789a0781a6e9e43',
  measurementId: 'G-NREYEH7YEW'
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const pushMessaging = firebase.messaging();

//for foreground messages
pushMessaging.onMessage((payload) => {
  navigator
    .serviceWorker
    .getRegistration('/firebase-cloud-messaging-push-scope')
    .then(registration => {
      let notificationOptions = Object.assign({}, payload.data);
      notificationOptions.data = payload.data;

      registration.showNotification(
        (payload.data ? payload.data.title : ''),
        notificationOptions
      );
    });
});

export default pushMessaging;
